import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6f4510dc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "related-orders-popup"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "header"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "选择地址", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "sub-title"
}, "奖品的收货地址与关联订单地址一致", -1));
const _hoisted_6 = {
  key: 0,
  class: "loading-container"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "loading-text"
}, "加载中...", -1));
const _hoisted_8 = {
  key: 1,
  class: "empty-container"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "empty-text"
}, "暂无关联订单数据", -1));
const _hoisted_10 = [_hoisted_9];
const _hoisted_11 = {
  key: 2,
  class: "order-list"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  class: "address-info"
};
const _hoisted_14 = {
  class: "customer-name"
};
const _hoisted_15 = {
  class: "address-detail"
};
const _hoisted_16 = {
  class: "product-section"
};
const _hoisted_17 = {
  class: "item-left"
};
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  class: "item-right"
};
const _hoisted_20 = {
  class: "product-title"
};
const _hoisted_21 = {
  class: "product-info"
};
const _hoisted_22 = {
  class: "product-price"
};
const _hoisted_23 = {
  key: 0,
  class: "product-count"
};
const _hoisted_24 = {
  class: "footer"
};
const _hoisted_25 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_loading = _resolveComponent("van-loading");
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_popup, {
    show: $options.ifShow,
    "onUpdate:show": _cache[2] || (_cache[2] = $event => $options.ifShow = $event),
    position: "bottom",
    round: "",
    "close-on-click-overlay": "",
    "safe-area-inset-bottom": ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_van_icon, {
      class: "icon",
      name: "close",
      size: "20",
      onClick: _cache[0] || (_cache[0] = _withModifiers($event => $options.closePopup(), ["stop"]))
    }), _hoisted_5]), $data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_van_loading, {
      type: "spinner",
      color: "#1989fa"
    }), _hoisted_7])) : $options.ordersList.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10)) : (_openBlock(), _createElementBlock("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.ordersList, (order, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["order-item", {
          'selected': $data.selectedIndex === index
        }]),
        key: index,
        onClick: $event => $options.chooseAddress(order, index)
      }, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(order.address_info.address_name) + " " + _toDisplayString($options.maskPhone(order.address_info.address_mobile)), 1), _createElementVNode("div", _hoisted_15, _toDisplayString(order.address_info.province) + " " + _toDisplayString(order.address_info.city) + " " + _toDisplayString(order.address_info.county) + " " + _toDisplayString(order.address_info.street) + " " + _toDisplayString(order.address_info.address), 1)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("img", {
        class: "product-img",
        src: `${_ctx.$imgUrlFilter(order.show_img, 100)}`,
        alt: "商品图片"
      }, null, 8, _hoisted_18)]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, _toDisplayString(order.reward_title), 1), _createElementVNode("div", _hoisted_21, [_createElementVNode("span", _hoisted_22, _toDisplayString(order.show_amount), 1), order.order_num ? (_openBlock(), _createElementBlock("span", _hoisted_23, "×" + _toDisplayString(order.order_num), 1)) : _createCommentVNode("", true)])])])], 10, _hoisted_12);
    }), 128))])), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", {
      class: _normalizeClass(["confirm-button", {
        'disabled': $data.selectedIndex === -1 || $data.loading
      }]),
      onClick: _cache[1] || (_cache[1] = $event => !$data.loading && $data.selectedIndex !== -1 && $options.confirmSelection())
    }, [$data.loading ? (_openBlock(), _createBlock(_component_van_loading, {
      key: 0,
      type: "spinner",
      color: "#ffffff",
      size: "24px"
    })) : (_openBlock(), _createElementBlock("span", _hoisted_25, "确定"))], 2)])])]),
    _: 1
  }, 8, ["show"])]);
}